<p-card [attr.data-shot-id]="segment.value.id">
  <ng-template #header>
    <header class="flex items-center p-[var(--p-card-body-padding)]">
      @if (segment.controls.clips.length) {
        <p-inputgroup class="w-full md:!w-56">
          <p-inputgroup-addon>
            {{ segment.controls.clips.length }}
          </p-inputgroup-addon>
          <p-select
            [options]="clips"
            [(ngModel)]="selectedClip"
            (onChange)="onAudioClipSelect($event)"
            optionLabel="name"
            placeholder="Select Audio">
            <ng-template let-option #item>
              <div class="w-full flex items-center justify-between space-x-2">
                <span>{{ option.name }}</span>
                <p-button
                  text
                  rounded
                  icon="pi pi-trash"
                  severity="danger"
                  aria-label="Delete Audio Clip"
                  (onClick)="onAudioClipDeleteClick(option.control)" />
              </div>
            </ng-template>
          </p-select>
        </p-inputgroup>
      } @else {
        <ng-container *ngTemplateOutlet="generate" />
      }
      <div class="flex items-center ml-auto space-x-2">
        @if (selectedClip) {
          <app-audio-clip [clip]="selectedClip.control" />
        }
        <div class="flex items-center">
          @if (segment.controls.clips.length) {
            <ng-container *ngTemplateOutlet="generate" />
          }
          <p-button
            text
            rounded
            icon="pi pi-ban"
            severity="danger"
            aria-label="Delete Audio Segment"
            (onClick)="onDeleteClick()" />
          @if (hasChanges) {
            <p-button
              text
              rounded
              icon="pi pi-undo"
              severity="warn"
              aria-label="Reset Audio Segment"
              (onClick)="onResetClick()" />
          }
          @if (!segment.value.id) {
            <p-button
              text
              rounded
              pTooltip="Not saved yet"
              icon="pi pi-bolt"
              severity="info"
              disabled />
          }
        </div>
      </div>
    </header>
  </ng-template>
  <textarea
    pTextarea
    fluid
    [minRows]="3"
    autosize
    [formControl]="segment.controls.text"
    placeholder="Start typing text..."></textarea>
</p-card>
<div class="flex items-center justify-center mt-6">
  <p-button
    rounded
    outlined
    icon="pi pi-plus"
    severity="info"
    aria-label="Add Audio Segment"
    (onClick)="onAddSectionClick()" />
</div>

<ng-template #generate>
  @if (segment.value.id) {
    <p-button
      text
      rounded
      icon="pi pi-sparkles"
      label="Generate"
      aria-label="Generate Audio Clip"
      appThrottleClick
      [throttleTime]="500"
      (throttleClick)="onAudioClipGenerateClick()" />
  }
</ng-template>
